// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.applicant.ApplicantsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId,
  ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetApplicantsForPropertyApplicationIdWebApiResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetApplicantsForPropertyApplicationIdParams {
  applicationId: string;
  listingAlias: string;
}

export type ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_Options = UseQueryOptions<
  GetApplicantsForPropertyApplicationIdWebApiResponseDto,
  unknown,
  GetApplicantsForPropertyApplicationIdWebApiResponseDto,
  readonly [string, GetApplicantsForPropertyApplicationIdParams]
>;

const ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_GetKey = (
  getParams: GetApplicantsForPropertyApplicationIdParams,
) => [ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_Path, getParams] as const;

export const ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_queryOptions = (
  getParams: GetApplicantsForPropertyApplicationIdParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_GetKey(getParams),
    queryFn: () => ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get applicants for a property by applicationId
 */
export const useApplicantsWebApiHandler_getApplicantsForPropertyApplicationId = (
  getParams: GetApplicantsForPropertyApplicationIdParams,
  {
    httpClient,
    ...options
  }: Omit<ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useApplicantsWebApiHandler_getApplicantsForPropertyApplicationId.getKey =
  ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_GetKey;
